import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { shallowEqual } from 'react-redux'

import { getAudit } from 'store/audit/auditSlice'

import { useAppDispatch, useAppSelector } from 'store/hooks'
import { State } from 'store/state'

export const useTitle = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const { auditStatus } = useAppSelector(
    (state: State) => ({
      auditStatus: state.auditReducer.status,
    }),
    shallowEqual
  )

  useEffect(() => {
    if (!auditStatus) {
      dispatch(getAudit())
    }
  })

  const companyAssessmentProgress = (auditStatus?.company?.progress ?? 0) * 100

  const percent = Math.round(companyAssessmentProgress) || 0

  const completed = percent === 100

  return {
    title: t('areas.assessment'),
    status: {
      title: `${percent}%`,
      type: completed ? 'completed' : (percent > 0 && 'reviewing') || 'pending',
    },
    done: completed,
    percent,
  }
}
